import './ScreenHolder.css'

function ScreenHolder({children}) {
  return (
    <div className='screen-holder'>{children}</div>
  )
}

export default ScreenHolder